module.exports = __webpack_public_path__ + "img/img3.56b0f909.jpg";